import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@mlm/ui';
import { useBrand } from '../storefront/lib/hooks';
import { KitGrid } from './kit-grid';

/**
 * "Browse kits" for a member without a slot.
 *
 * Both Browse-kits buttons used to link to `/storefront` — the WHOLE catalog,
 * which has no kit filter, no kit tab and no kit badge (`grep isKit` over the
 * storefront finds nothing). A slotless member was dropped into a general
 * product grid and left to work out which of it activates them.
 *
 * The body is the shared `KitGrid` — the same component as the dashboard's
 * "Pick your activation kit" card, so the two surfaces can't drift.
 */
export function KitPickerDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const brand = useBrand();
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Pick your {brand.activationKitLabel}</DialogTitle>
          <DialogDescription>
            Buying a {brand.kitLabel} creates a Code + PIN you redeem to activate your first slot.
          </DialogDescription>
        </DialogHeader>
        <KitGrid
          enabled={open}
          onPicked={onClose}
          gridClassName="grid max-h-[60vh] grid-cols-1 gap-3 overflow-y-auto pr-1 sm:grid-cols-2 lg:grid-cols-3"
        />
      </DialogContent>
    </Dialog>
  );
}
